import * as React from 'react';
import type { SVGProps } from 'react';
const SvgBashgah = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    xmlSpace='preserve'
    id='bashgah_svg__Layer_1'
    x={0}
    y={0}
    viewBox='0 0 566.9 566.9'
    {...props}
  >
    <style>{'.bashgah_svg__st0{fill:#7059a5}'}</style>
    <path
      d='m555.5 423.7-94.3 138c-44-48.1-107.2-78.2-177.5-78.2-72.8 0-138 32.3-182.1 83.4L11.4 424.2c47.8-43.4 105.9-75.5 170.3-92.2l69.2 109.4 26.6 42.1 28.1-41.1L381.7 331c65.7 16.3 125.2 48.7 173.8 92.7'
      className='bashgah_svg__st0'
    />
    <path
      d='m496.8 83.4-163 238.7-55 80.5-50.7-79.7L69.7 73.3 80.5 65C106.7 45.5 135 30.3 165 19.6c1.8-.6 3.6-1.3 5.4-1.9 1-.4 2.1-.8 3.2-1.1C203.9 6.6 235.8 1 268.5.2c2.5 0 5.1-.1 7.6-.1 7.6 0 15.1.2 22.4.7 37.2 2.3 73.5 11 107.5 25.4 1.1.4 2.2.9 3.3 1.4 27.8 12.1 54 28.1 77.6 47.6z'
      style={{
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        fill: '#7059a5',
      }}
    />
    <path
      d='M486.9 75.3c-23.6-19.5-49.8-35.5-77.6-47.6 30.9 14 59.6 32.8 87.5 55.8zm-417.2-2c30.7-22.8 61.7-41.1 95.3-53.7-30 10.7-58.3 25.9-84.5 45.4z'
      className='bashgah_svg__st0'
    />
  </svg>
);
export default SvgBashgah;
